import { render, staticRenderFns } from "./dragdrop.vue?vue&type=template&id=979befa6&"
import script from "./dragdrop.vue?vue&type=script&lang=js&"
export * from "./dragdrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports